import { render, staticRenderFns } from "./ManualDescription.vue?vue&type=template&id=2cf0a372&"
import script from "./ManualDescription.vue?vue&type=script&lang=js&"
export * from "./ManualDescription.vue?vue&type=script&lang=js&"
import style0 from "./ManualDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports